import { render, staticRenderFns } from "./ChooseBox.vue?vue&type=template&id=361cbf7c&scoped=true&"
import script from "./ChooseBox.vue?vue&type=script&lang=js&"
export * from "./ChooseBox.vue?vue&type=script&lang=js&"
import style0 from "./ChooseBox.vue?vue&type=style&index=0&id=361cbf7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361cbf7c",
  null
  
)

export default component.exports